import { render, staticRenderFns } from "./AgentDashboard.vue?vue&type=template&id=afb98bac&scoped=true&"
import script from "./AgentDashboard.vue?vue&type=script&lang=js&"
export * from "./AgentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AgentDashboard.vue?vue&type=style&index=0&id=afb98bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb98bac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VSimpleTable})
